// ── Color Palette ──────────────────────────────────────────────────────────
// BeWell Sidecar — "Ocean" palette: cyan-700 primary with a magenta-600
// accent. Vivid + fintech-leaning, reads as 'live & connected'. Visually
// distinct from the admin app's deep navy. primary/primaryHover/primaryLight
// feed every shared primitive (buttons, active nav, links) so the microsite
// brand applies everywhere automatically.
export const colors = {
    // ── Brand (Cyan #0E7490 + Magenta #DB2777) ───────────────────────────
    primary: "#0E7490",
    primaryHover: "#0B5C73",
    primaryLight: "#ECFEFF",
    accent: "#DB2777",
    // ── Status ────────────────────────────────────────────────────────────
    success: "#059669",
    successLight: "#ECFDF5",
    danger: "#E11D48",
    dangerLight: "#FFF1F2",
    dangerDark: "#991B1B",
    dangerBorder: "#FCA5A5",
    warning: "#D97706",
    warningLight: "#FFFBEB",
    warningDark: "#92400E",
    warningBorder: "#FCD34D",
    info: "#6366F1",
    infoLight: "#EEF2FF",
    // ── Text ──────────────────────────────────────────────────────────────
    text: "#0F172A",
    textSecondary: "#64748B",
    textTertiary: "#94A3B8",
    textDisabled: "#CBD5E1",
    textOnColor: "#FFFFFF",
    // ── Surfaces ──────────────────────────────────────────────────────────
    surface: "#FFFFFF",
    surfaceSecondary: "#F8FAFC",
    surfaceTertiary: "#F1F5F9",
    bg: "#F8FAFC",
    cardBg: "#FFFFFF",
    bgHover: "#ECFEFF",
    textMuted: "#64748B",
    // ── Borders ───────────────────────────────────────────────────────────
    border: "#E2E8F0",
    divider: "#F1F5F9",
    // ── Accent palette ────────────────────────────────────────────────────
    purple: "#8B5CF6",
    teal: "#14B8A6",
    amber: "#F59E0B",
    indigo: "#6366F1",
    slate: "#64748B",
    rose: "#E11D48",
    // ── Shadows ───────────────────────────────────────────────────────────
    shadowSm: "0 1px 2px rgba(0,0,0,0.04)",
    shadowMd: "0 2px 8px rgba(0,0,0,0.06)",
    shadowLg: "0 4px 16px rgba(0,0,0,0.08)",
};
export const statusColors = {
    planned: colors.primary,
    booked: colors.success,
    confirmed: colors.success,
    partial: colors.warning,
    completed: colors.textTertiary,
    unfulfilled: colors.danger,
    unfulfillable: colors.danger,
    skipped: colors.textTertiary,
    pending: colors.warning,
    scheduled: colors.warning,
    cancelled: colors.textTertiary,
    failed: colors.danger,
    ok: colors.success,
    error: colors.danger,
};
/**
 * Per-court identity colours for the court×time grid (ported from the main app).
 * Colour = WHICH court (C1–C4…), NOT status — status is shown by fill pattern
 * (solid = booked, striped = pending, red hatch = unbookable). Up to 8 courts.
 */
export const courtColors = {
    1: colors.primary,
    2: colors.rose,
    3: colors.purple,
    4: "#0891B2",
    5: colors.amber,
    6: colors.teal,
    7: colors.indigo,
    8: colors.slate,
};
// ── Reusable Style Objects ─────────────────────────────────────────────────
export const cardStyle = {
    border: `1px solid ${colors.border}`,
    borderRadius: 10,
    padding: 16,
    background: colors.surface,
    boxShadow: colors.shadowSm,
};
export const panelStyle = {
    border: `1px solid ${colors.border}`,
    borderRadius: 8,
    padding: 12,
    background: colors.surface,
    marginBottom: 8,
};
export const inputStyle = {
    border: `1px solid ${colors.border}`,
    borderRadius: 8,
    padding: "8px 12px",
    fontSize: "0.85rem",
    outline: "none",
    transition: "border-color 0.2s, box-shadow 0.2s",
    background: colors.surface,
};
export const buttonBase = {
    border: "none",
    borderRadius: 8,
    padding: "8px 14px",
    cursor: "pointer",
    fontSize: "0.85rem",
    fontWeight: 500,
    transition: "opacity 0.15s",
};
export const buttonGhostStyle = {
    ...buttonBase,
    background: "transparent",
    border: "1px solid transparent",
    color: "inherit",
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
};
